
import { oz } from '@weft/utils';

export const RevenueBreakdownSchema = oz.object({
  total: oz.number(),
  subtotal: oz.number(),
  overage: oz.number(),
  discount: oz.number(),
  creditsUsed: oz.number(),
  tax: oz.number().nonnegative(),
});

export type RevenueBreakdown = oz.TypeOf<typeof RevenueBreakdownSchema>;